import { useRef, useEffect, useState } from "react";
import { Button } from "@/components/ui/button";

export function SignaturePad({ onSubmit, submitting }) {
  const canvasRef = useRef(null);
  const drawing = useRef(false);
  const [hasInk, setHasInk] = useState(false);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    ctx.lineWidth = 2.4;
    ctx.lineCap = "round";
    ctx.lineJoin = "round";
    ctx.strokeStyle = "#0D0D0D";
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, canvas.width, canvas.height);
  }, []);

  const pos = (e) => {
    const canvas = canvasRef.current;
    const rect = canvas.getBoundingClientRect();
    const t = e.touches ? e.touches[0] : e;
    return {
      x: (t.clientX - rect.left) * (canvas.width / rect.width),
      y: (t.clientY - rect.top) * (canvas.height / rect.height),
    };
  };
  const start = (e) => { e.preventDefault(); drawing.current = true; const ctx = canvasRef.current.getContext("2d"); const p = pos(e); ctx.beginPath(); ctx.moveTo(p.x, p.y); };
  const move = (e) => { if (!drawing.current) return; e.preventDefault(); const ctx = canvasRef.current.getContext("2d"); const p = pos(e); ctx.lineTo(p.x, p.y); ctx.stroke(); setHasInk(true); };
  const end = () => { drawing.current = false; };

  const clear = () => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    setHasInk(false);
  };
  const submit = () => { if (hasInk) onSubmit(canvasRef.current.toDataURL("image/png")); };

  return (
    <div className="space-y-3" data-testid="signature-pad">
      <canvas
        ref={canvasRef}
        width={520}
        height={180}
        className="w-full border border-border bg-white touch-none cursor-crosshair"
        onMouseDown={start}
        onMouseMove={move}
        onMouseUp={end}
        onMouseLeave={end}
        onTouchStart={start}
        onTouchMove={move}
        onTouchEnd={end}
        data-testid="signature-canvas"
      />
      <div className="flex items-center justify-between">
        <button type="button" onClick={clear} data-testid="signature-clear" className="text-xs font-mono tracking-wide text-muted-foreground hover:text-foreground transition-colors">
          Clear
        </button>
        <Button onClick={submit} disabled={!hasInk || submitting} data-testid="signature-submit" className="rounded-none bg-primary hover:bg-primary/90 font-mono text-xs tracking-wide">
          {submitting ? "Signing…" : "Sign & submit"}
        </Button>
      </div>
    </div>
  );
}
